import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import CurrentStateModel from '$fbusiness/models/currentState';
import UserModel from '$gbusiness/models/user';
import { DEFAULT_PUBLIC } from '$business/enums/routes';

export interface PrivateRouteProps extends RouteProps {
  currentState: CurrentStateModel;
  isAccessible: boolean;
  feature?: string;
  component: React.FC;
  user?: UserModel;
  path?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  user,
  component,
  feature,
  path = '',
  currentState,
  isAccessible,
  ...rest
}) => {
  const { isLoggedIn } = currentState;
  console.log('PRIVATE', DEFAULT_PUBLIC);
  const routeComponent = (props: any) =>
    isLoggedIn ? (
      React.createElement(component, { ...props, currentState, feature, user })
    ) : (
      <Redirect to={DEFAULT_PUBLIC.path} />
    );

  return isAccessible ? <Route {...rest} render={routeComponent} /> : null;
};

export default PrivateRoute;
